import { useSelector } from 'react-redux'
import { selectors } from 'shared/store'
import { Option } from 'shared/types'

export const useCoutriesOptions = () => {
  const countriesOptions = useSelector(
    selectors.settings.getCountriesOptions
  ) as Option<string, number>[]

  return countriesOptions || []
}
